<app-stages [stages]="stages" currentStage="Lokalizacja"></app-stages>
<br>
<ng-container *ngIf='!pending() && !loading()'>
  <form autocomplete="off" novalidate [formGroup]="form" (ngSubmit)='submitAndGoNext()'>
    <fieldset>
      <app-exposed-map-control
        #exposedMapControl
        [control]="form.geometry">
      </app-exposed-map-control>
      <app-road-controls-set [expMapDict]="exposedMapControl.dictEvent()" [form]="form"></app-road-controls-set>
    </fieldset>
    <fieldset>
      <legend>
        {{ application() | locationReconstructionOfExitApplicationParcelsSectionTitle }}
      </legend>
      <app-parcels-crud
        expMapDictPlotType="Drogowa"
        [expMapDict]="exposedMapControl.dictEvent()"
        tag="parcels"
        formControlName="parcels">
      </app-parcels-crud>
    </fieldset>
    <fieldset>
      <legend>
        {{ application() | locationReconstructionOfExitApplicationParcels2SectionTitle }}
      </legend>
      <app-parcels-crud
        expMapDictPlotType="Powiązana"
        [expMapDict]="exposedMapControl.dictEvent()"
        tag="parcels2"
        formControlName="parcels2">
      </app-parcels-crud>
    </fieldset>
    <br>
    <fieldset>
      <legend>
        Informacje o nieruchomości
      </legend>
      <div class="row">
        <div class='col-md-4'>
          <div class='form-group' *ngIf='"propertyLegalTitle" as controlName'>
            <label [for]='controlName'>
              Tytuł prawny do nieruchomości *
            </label>
            <select
              (change)="form.propertyLegalTitleChange(form.getElement($event).value)"
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'>
              <option value=''>Wybierz</option>
              <option [value]='item.id' *ngFor='let item of form.propertyLegalTitles()'>
                {{ item.name }}
              </option>
            </select>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
        @if (form.propertyLegalTitleDesc) {
          <div class='col-md-6' *ngIf='"propertyLegalTitleDesc" as controlName'>
            <div class='form-group' *ngIf="form.get(controlName)">
              <label [for]='controlName'>
                Inny tytuł prawny *
              </label>
              <textarea
                [id]='controlName'
                [ngClass]='{ "is-invalid": form.showError(controlName) }'
                [formControlName]='controlName'
                placeholder='Wpisz tu inny tytuł prawny'></textarea>
              <app-validation-errors [showTextLength]="true" [control]='form.get(controlName)'>
              </app-validation-errors>
            </div>
          </div>
        }
      </div>
      <div class="row">
        <div class='col-md-4'>
          <div class='form-group' *ngIf='"purposeOfUse" as controlName'>
            <label [for]='controlName'>
              Obecny sposób wykorzystania nieruchomości *
            </label>
            <select
              (change)="form.purposeOfUseChange(form.getElement($event).value)"
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'>
              <option value=''>Wybierz</option>
              <option [value]='item' *ngFor='let item of form.purposeOfUseList'>
                {{ item }}
              </option>
            </select>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
        <div class='col-md-6' *ngIf='"purposeOfUseDesc" as controlName'>
          <div class='form-group' *ngIf="form.get(controlName)">
            <label [for]='controlName'>
              Inny sposób *
            </label>
            <textarea
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'
              placeholder='Wpisz tu inny sposób'></textarea>
            <app-validation-errors [showTextLength]="true" [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
      </div>
      <div class="row">
        <div class='col-md-4'>
          <div class='form-group' *ngIf='"postInvestmentUsage" as controlName'>
            <label [for]='controlName'>
              Sposób wykorzystania nieruchomości po wybudowaniu zjazdu *
            </label>
            <select
              (change)="form.postInvestmentUsageChange(form.getElement($event).value)"
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'>
              <option value=''>Wybierz</option>
              <option [value]='item' *ngFor='let item of form.postInvestmentUsages'>
                {{ item }}
              </option>
            </select>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
        <div class='col-md-6' *ngIf='"propertyUsageChange" as controlName'>
          <div class='form-group' *ngIf="form.get(controlName)">
            <label [for]='controlName'>
              Zmiana wykorzystania nieruchomości *
            </label>
            <textarea
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'
              placeholder='Opisz tu zmiany wykorzystania nieruchomości'></textarea>
            <app-validation-errors [showTextLength]="true" [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
      </div>
      <div class="row">
        <div class='col-md-4'>
          <div class='form-group' *ngIf='"referenceVehicleType" as controlName'>
            <label [for]='controlName'>
              <br>Rodzaj pojazdu miarodajnego, <br> który będzie obsługiwał zjazd *
            </label>
            <select
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'>
              <option value=''>Wybierz</option>
              <option value='Pojazd osobowy'>Pojazd osobowy</option>
              <option value='Pojazd komunalny'>Pojazd komunalny</option>
              <option value='Pojazd ciężarowy bez przyczepy'>Pojazd ciężarowy bez przyczepy</option>
              <option value='Pojazd ciężarowy z przyczepą'>Pojazd ciężarowy z przyczepą</option>
              <option value='Ciągnik rolniczy z dwiema przyczepami'>Ciągnik rolniczy z dwiema przyczepami</option>
              <option value='Autobus dwuosiowy'>Autobus dwuosiowy</option>
              <option value='Autobus trzyosiowy'>Autobus trzyosiowy</option>
              <option value='Autobus przegubowy'>Autobus przegubowy</option>
            </select>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
        <div class='col-md-4'>
          <div class='form-group' *ngIf='"propertyParkingSpacesCount" as controlName'>
            <label [for]='controlName'>
              Liczba stanowisk postojowych na <br> terenie nieruchomości do <br> której prowadził będzie zjazd *
            </label>
            <input
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'
              mask="0*"
              placeholder='Wpisz tu liczbę stanowisk'
              type='text'>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
      </div>
    </fieldset>
    <div class='application-actions'>
      <button
        type='button'
        class='btn btn-secondary'
        (click)='onCancel()'>
        <span>Wstecz</span>
      </button>
      <button
        type='button'
        class='btn btn-primary'
        (click)='submitAndGoNext()'>
        <span>Zapisz i przejdź dalej</span>
      </button>
    </div>
  </form>
</ng-container>
<app-spinner *ngIf='pending()'>
  Poczekaj trwa zapisywania danych...
</app-spinner>
<app-spinner *ngIf='loading()'>
  Poczekaj trwa ładowanie danych...
</app-spinner>
